import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsShazamComponent } from './simple-icons-shazam.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsShazamComponent ],
    exports:      [ SimpleIconsShazamComponent ],
    bootstrap:    []
})
export class SimpleIconsShazamModule {}
